import type { ValidatorConstraintInterface } from "class-validator";
import { ValidatorConstraint } from "class-validator";

const BICRegex = /^[a-z]{4}[a-z]{2}[a-z0-9]{2}([a-z0-9]{3}|)$/i;

@ValidatorConstraint({ name: "is BIC" })
export class IsBICValidator implements ValidatorConstraintInterface {
    public validate(rawBIC: string): boolean {
        if (!rawBIC) {
            return false;
        }

        const l = rawBIC.length;

        if (l !== 8 && l !== 11) {
            return false;
        }

        return BICRegex.test(rawBIC);
    }

    public defaultMessage(): string {
        return "BIC is in wrong format.";
    }
}
